// Отдано ли с фермы в этом ходу снабжение, которое можно отменить: двойной
// клик по ферме возвращает ей последнее такое снабжение (см.
// UNDO_FARM_PENDING_SUPPLY). Батч доп. снабжения великанов ссылается на
// несколько ферм сразу (farmHexKeys) и считается отданным с каждой из них
export const checkIfFarmHasUndoableSupply = (pendingSupply, farmHexKey) => (pendingSupply || []).some(
  (supply) => !supply.isNotUndoable
    && (supply.farmHexKey === farmHexKey || Boolean(supply.farmHexKeys?.includes(farmHexKey)))
);
